import React, { useEffect } from "react";
import DashboardCard from "./DashboardCard";
import { Box, Container, Grid } from "@mui/material";
import Header from "src/Component/content-component/Header";
import { useDispatch, useSelector } from "react-redux";
import { getPlanStatusForHomePageAsync } from "src/redux/services/studyAbroadServices";
import { WEB_URL } from "src/config";
const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;

const stbg = imageBaseUrl + "homestudybg.svg";
const imbg = imageBaseUrl + "homeimmigrationbg.svg";
const mbbg = imageBaseUrl + "homembbsbg.svg";
const tpbg = imageBaseUrl + "hometestprepbg.svg";
const st = imageBaseUrl + "homestudyabroad.svg";
const im = imageBaseUrl + "homeBanner/immersion.jpg";
const mb = imageBaseUrl + "homeBanner/IR.jpg";
const tp = imageBaseUrl + "hometest.svg";

const DashboardHome = () => {
  const dispatch = useDispatch();
  const { getPlanStatusForHomePage } = useSelector(
    (state) => state.studyAbroad
  );
  const { isStudyAbroadApproved, isLoading } = getPlanStatusForHomePage || {};

  useEffect(() => {
    dispatch(getPlanStatusForHomePageAsync());
  }, [dispatch]);

  const ourserviceshomedata = [
    {
      background: stbg,
      image: st,
      title: "STUDY ABROAD",
      path: "/dashboard/admission",
      para: "Discover top universities and programs worldwide to advance your education and career. Our experts guide you through admissions, visas, and scholarships.",
      showButtons: true,
      showFirstButton: isStudyAbroadApproved ? true : false,
      showSecondButton: isStudyAbroadApproved ? false : true,
      secondButtonPath: "/dashboard/studyabroad-purchase",
    },
    {
      background: imbg,
      image: im,
      title: "IMMERSION",
      path: `${WEB_URL}immersion`,
      para: "Strengthen global networks and foster cross-cultural collaboration for academic and professional growth. We help you navigate international partnerships and exchanges.",
      showButtons: true,
      showFirstButton: true,
      showSecondButton: false,
    },
    {
      background: mbbg,
      image: mb,
      title: "International Engagement",
      path: `${WEB_URL}international-relation`,
      para: "Experience deep cultural and language learning through tailored programs abroad. Accelerate fluency while living and studying in your target country.",
      showButtons: true,
      showFirstButton: true,
      showSecondButton: false,
    },
    {
      background: tpbg,
      image: tp,
      title: "TEST PREP",
      path: "/dashboard/test-prep",
      para: "Achieve your best scores with personalized coaching for exams like IELTS, TOEFL, PTE, GRE, GMAT, SAT. Our proven strategies boost confidence and performance.",
      showButtons: true,
      // showFirstButton: isTestPrep ? true : false,
      // showSecondButton: isTestPrep ? false : true,
      showFirstButton: true,
      secondButtonPath: "/test",
    },
  ];

  return (
    <Container maxWidth="xl" sx={{ mt: 2 }}>
      <Box sx={{ mb: "20px", mt: 4 }}>
        <Header color="#00999e" textAlign="center" content="Our Services" />
      </Box>
      <Grid
        container
        spacing={3}
        sx={{
          display: "flex",
          justifyContent: "center",
          padding: "0 16px",
        }}
      >
        {ourserviceshomedata?.map((item, index) => (
          <Grid
            item
            key={index}
            xs={12}
            sm={6}
            md={6}
            lg={5.8}
            xl={5.8}
            display="flex"
            justifyContent="center"
          >
            <DashboardCard
              data={item}
              id={index + 1}
              sx={{ width: "100%" }}
              isLoading={isLoading}
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default DashboardHome;
